import createApp from '@/createApp';
import createAppRegistry from '@/createAppRegistry';

createAppRegistry(createApp);
